import {DESKTOP, PHONE_LANDSCAPE, TABLET} from "@irati/ui/src/global/media"

export const SliderSettings = {
  slidesToShow: 3, // Default for large screens
  slidesToScroll: 1,
  infinite: false,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: PHONE_LANDSCAPE - 1,
      settings: {slidesToShow: 1.2, slidesToScroll: 1}
    },
    {
      breakpoint: TABLET - 1,
      settings: {slidesToShow: 1.2, slidesToScroll: 1}
    },
    {
      breakpoint: DESKTOP - 1,
      settings: {slidesToShow: 2, slidesToScroll: 2}
    }
  ]
}
